import type { FILTERS } from '~/types/ui'

interface State {
  filters: {
    [key in FILTERS]?: any
  }
}

export const useFiltersStore = defineStore(
  'filters',
  () => {
    const filters = ref<State['filters']>({})

    const setFilter = (name: FILTERS, value: any) => {
      filters.value[name] = value
    }

    const clearFilters = () => {
      filters.value = {}
    }

    const getFilter = (name: FILTERS) => filters.value[name]

    return {
      filters,
      setFilter,
      clearFilters,
      getFilter,
    }
  },
  {
    persist: true,
  }
)
